<template>
  <div
    :class="`${createRenderType}-sub-plan`"
    class="flex-column-center sub-plan"
  >
    <div class="tab flex">
      <div
        class="tab-item"
        :class="activeIndex == index ? 'tab-item-active' : ''"
        v-for="(item, index) in tabList"
        :key="index"
        @click="changeTab(index)"
      >
        {{ $t(item) }}
      </div>
    </div>
    <div class="list flex">
      <div
        class="item flex-column"
        v-for="(item, index) in activeIndex == 0 ? yearList : monthList"
        :key="item.product_id"
        :class="{
          'item-exclusive-active':
            GlobalConfig.appname != 'Mureka' &&
            item.level_name == 'pro' &&
            item.period_name == 'year',
          'item-cn': GlobalConfig.appname != 'Mureka',
          'item-high-active': containsDesc(item.common_desc),
          'item-pre-price': [
            'show_yearly_96_288',
            'show_yearly_price_96_288',
          ].includes(subscriptionPriceType),
        }"
      >
        <div
          class="cutdown flex-row-center"
          v-if="item.extra_credit && countdown"
        >
          <div v-if="!userDataStore.countdown" class="duration flex-row-center">
            <img src="@/assets/img/credit/cut.png" alt="" />
            <div class="ctime">{{ formatTime(countdown) }}</div>
          </div>
          <div class="extra-credit" :class="{exclusive: userDataStore.countdown}">
            {{
              userDataStore.countdown
                ? $t("credit.subscribe_in_15", { extra_credit: item.extra_credit })
                : $t("credit.checkoutForExtra", { extra_credit: item.extra_credit })
            }}
            <!-- Checkout for <br />
            extra {{ item.extra_credit }} credits -->
          </div>
        </div>
        <div
          class="title flex-row-center"
          v-if="GlobalConfig.appname == 'Mureka'"
        >
          <img :src="getObjectStorageFullUrl(item.icon_url)" alt="" />
          <div>{{ item.short_title }}</div>
        </div>
        <div
          v-else
          :class="{
            'cn-title': true,
            'flex-row-center': true,
            'cn-title-exclusive': item.level_name == 'pro',
            'cn-title-normal': item.level_name == 'basic',
          }"
        >
          <div class="short" :class="`short-${item.period_name}`">
            {{ item.short_title }}
          </div>
          <div
            v-if="item.level_name == 'pro'"
            class="flex-row-center"
            :class="`period-${item.period_name}`"
          >
            {{ item.period_name == "year" ? "年度" : "月度" }}
          </div>
          <div v-else class="">
            ( {{ item.period_name == "year" ? "年度" : "月度" }} )
          </div>
        </div>
        <div
          v-if="
            activeIndex == 0 &&
            ['show_yearly_96_288', 'show_yearly_price_96_288'].includes(
              subscriptionPriceType
            )
          "
          class="pre-price"
        >
          {{ priceFalg }} {{ item.pre_price }}
        </div>
        <div v-if="GlobalConfig.appname != 'Mureka'" class="show-total-price">
          {{ priceFalg }} {{ item.new_price }}
        </div>
        <div class="price flex">
          <div class="flag" v-if="GlobalConfig.appname == 'Mureka'">
            {{ priceFalg }}
          </div>
          <div class="flex">
            <div class="num" v-if="GlobalConfig.appname == 'Mureka'">
              {{
                (activeIndex == 0 &&
                  ["show_yearly_96_288", "show_yearly_price_96_288"].includes(
                    subscriptionPriceType
                  )) ||
                activeIndex == 1
                  ? item.new_price
                  : item.new_price / 12
              }}
            </div>
            <div class="num num-active" v-else>{{ item.sub_desc }}元</div>
            <div
              class="month"
              :class="GlobalConfig.appname != 'Mureka' ? 'month-active' : ''"
            >
              /{{
                GlobalConfig.appname != "Mureka"
                  ? "首"
                  : activeIndex == 0 &&
                    ["show_yearly_96_288", "show_yearly_price_96_288"].includes(
                      subscriptionPriceType
                    )
                  ? $t("credit.year")
                  : $t("credit.month")
              }}
            </div>
          </div>
        </div>
        <div
          class="total break"
          :class="{
            pointer: activeIndex == 1,
            'under-line': activeIndex == 1 && GlobalConfig.appname == 'Mureka',
            'total-active': GlobalConfig.appname != 'Mureka',
          }"
          @click="activeIndex == 1 ? (activeIndex = 0) : ''"
        >
          {{ item.unit_price }}
        </div>
        <div
          class="btn"
          :class="{
            'btn-disabled': item.in_effect == 1,
            pointer: item.in_effect != 1,
            'is-loading': isloading && handleIndex == index,
          }"
          @click="handleCheckout(item, index)"
        >
          <div class="common">
            {{
              item.in_effect == 1
                ? $t("create.active")
                : GlobalConfig.appname == "Mureka"
                ? $t("common.nav_credits")
                : "购买"
            }}
          </div>
          <div class="loading"></div>
        </div>
        <div class="explain">
          <div
            class="flex"
            :class="containsDesc([citem]) ? 'active' : ''"
            v-for="citem in item.common_desc"
            :key="citem"
          >
            {{ citem.replace(/^\[.*\]/, "").trim() }}
          </div>
          <div
            class="flex gary"
            v-for="citem in item.gray_common_desc"
            :key="citem"
          >
            {{ citem }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  watch,
  defineEmits,
  onMounted,
  onUnmounted,
  defineProps,
  getCurrentInstance,
} from "vue";
import { useRoute } from "vue-router";
import {
  getNewProducts,
  getProducts,
  checkFirstPurchase,
} from "@/api/api/apiCredit.js";
import { getObjectStorageFullUrl } from "@/lib/objectStorage/objectStorage.js";
import { $$t } from "@/i18n/i18n.js";
import useUserDataStore from "@/store/userDataStore";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import useAbtestStore from "@/store/abtestStore";
import GlobalConfig from "@/config/config.js";

const globalProperties =
  getCurrentInstance()?.appContext.config.globalProperties;
const route = useRoute();
const emits = defineEmits([
  "changeSubEnable",
  "handleCheckout",
  "getProductList",
]);
const userDataStore = useUserDataStore();
const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);
const abtestStore = useAbtestStore();
const { subscriptionPriceType, subscriptionTabType } = storeToRefs(abtestStore);

const tabList = ref(["credit.yearPlan", "credit.monthPlan"]);
const activeIndex = ref(0);
const yearList = ref([]);
const monthList = ref([]);
const timer = ref(null);
const countdown = ref(0);
const handleIndex = ref(0);
const showIndex = ref(-1);
const tag1 = ref("");
const tag2 = ref("");
const disabledChangeTab = ref(false);
const isChangeTab = ref(true);
const priceFalg = GlobalConfig.appname != "Mureka" ? "¥" : "$";

const props = defineProps({
  isloading: {
    type: Boolean,
    default: true,
  },
  productList: {
    type: Array,
    default: () => [],
  },
});

watch(
  () => userDataStore.isLogin,
  (val) => {
    clearInterval(timer.value);
    countdown.value = "";
    timer.value = null;
    if (val) {
      // abtestStore.initSubscriptionPrice(getList);
      getList();
    }
  }
);

watch(
  () => userDataStore.appLanguage,
  () => {
    nextTick().then(() => {
      clearInterval(timer.value);
      countdown.value = "";
      timer.value = null;
      // abtestStore.initSubscriptionPrice(getList);
      getList();
    });
  }
);

watch(
  () => props.productList,
  () => {
    init();
  }
);

watch(
  () => countdown.value,
  (val) => {
    if (val === 0) {
      clearInterval(timer.value); // 倒计时结束，销毁定时器
    }
  }
);

watch(
  () => showIndex.value,
  (val) => {
    if (val == 0) {
      globalProperties.logViewEvent("subcrirbe_yearly", {});
    } else if (val == 1) {
      globalProperties.logViewEvent("subcrirbe_monthly", {});
    }
  }
);

const containsDesc = (list) => {
  if (!list) return;
  // if (userDataStore.userInfo?.user?.is_vip) {
  //   return false;
  // }
  const regex = /\[(.*?)\]/g;
  let flag = list.some((item) => {
    const matches = [...item.matchAll(regex)].map((match) => match[1]);
    // console.error(matches, "888888")
    return (
      (tag1.value && matches.some((content) => content.includes(tag1.value))) ||
      (tag2.value && matches.some((content) => content.includes(tag2.value)))
    );
  });

  return flag;
};

const changeTab = (index) => {
  activeIndex.value = index;
  showIndex.value = index;
};

const startCountdown = () => {
  timer.value = setInterval(() => {
    countdown.value--; // 每秒倒计时减一
  }, 1000);
};

const checkTime = () => {
  checkFirstPurchase({}).then((res) => {
    if (res.code == 200) {
      const { is_first, time_remaining } = res.data;
      if (is_first == 2 && time_remaining) {
        countdown.value = time_remaining;
        startCountdown();
      }
    }
  });
};

const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60); // 分钟数
  const remainingSeconds = seconds % 60; // 剩余的秒数

  let formattedMinutes = minutes;
  if (minutes === 0) {
    formattedMinutes = "00";
  }

  const formattedTime = `${formattedMinutes}:${String(
    remainingSeconds
  ).padStart(2, "0")}`;
  return formattedTime;
};

const handleCheckout = (item, index) => {
  handleIndex.value = index;
  emits("handleCheckout", item);
};

const getList = () => {
  emits("getProductList");
};

const init = () => {
  yearList.value = [];
  monthList.value = [];
  checkTime();

  let maxSubStartTime = 0;
  let latestActiveItem = null;

  props.productList.forEach((item) => {
    if (item.in_effect == 1) {
      if(item?.stripe_info?.in_effect == 1){
        emits("changeInEffect", "stripe");
      }
      if (item?.paypal_info?.in_effect == 1) {
        emits("changeInEffect", "paypal");
      }
      


      // Track the item with latest sub_start_time
      if (item.sub_start_time > maxSubStartTime) {
        maxSubStartTime = item.sub_start_time;
        latestActiveItem = item;
      }

      // Only check period_name when flag is true
      if (GlobalConfig.appname == "Mureka" && item.period_name == "month") {
        activeIndex.value = 1;
      }
    }
    if (GlobalConfig.appname == "Mureka") {
      if (item.period_name == "year") {
        yearList.value.push(item);
      } else {
        monthList.value.push(item);
      }
    } else {
      if (item.level_name == "pro") {
        yearList.value.push(item);
      } else {
        monthList.value.push(item);
      }
    }

    if (item.sub_state == 2 || item.sub_state == 4) {
      emits("changeSubEnable");
    }
  });
  if (GlobalConfig.appname != "Mureka" && isChangeTab.value) {
    if (latestActiveItem) {
      activeIndex.value = latestActiveItem.level_name === "pro" ? 0 : 1;
    }
  } else {
    activeIndex.value = 0;
  }

  showIndex.value = activeIndex.value;
};
// 获取tab
const getShowTab = () => {
  if (disabledChangeTab.value) return;
  abtestStore.initSubscriptionTab(() => {
    activeIndex.value =
      subscriptionTabType.value == "default_display_monthly_plan" ? 1 : 0;
  });
};

onMounted(() => {
  // getList();
  // abtestStore.initSubscriptionPrice()
  const { membership_source1, membership_source2, membership_source3 } =
    route.query;
  tag1.value = membership_source2;
  tag2.value = membership_source3;
  if (tag1.value || tag2.value) {
    isChangeTab.value = false;
  }
  globalProperties.logViewEvent("subcribe", {
    membership_source1: String(membership_source1 || ""),
    membership_source2: String(membership_source2 || ""),
    details: userDataStore.userInfo?.discount?.discount_percent 
      ? String(userDataStore.userInfo.discount.discount_percent) + '_off' 
      : "",
    type: String(userDataStore.userInfo?.discount?.discount_type ?? ""),
  });
});

onUnmounted(() => {
  timer.value && clearInterval(timer.value);
});

</script>

<style lang="scss" scoped>
.sub-plan {
  .tab {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 52px;
    padding: 4px;
    width: max-content;
    align-self: center;
    .tab-item {
      font-weight: 500;
      color: rgba(255, 255, 255, 0.5);
      margin-right: 4px;
      &:last-of-type {
        margin-right: 0;
      }
    }
    .tab-item-active {
      color: #000000;
      background: #fff;
    }
  }
  .list {
    .item {
      position: relative;
      box-sizing: border-box;
      background: rgba(127, 129, 165, 0.2);
      &-cn {
        background: linear-gradient(
          180deg,
          rgba(157, 190, 255, 0.17) 0%,
          rgba(30, 35, 121, 0.3) 100%
        );
      }
      &-high-active {
        background: rgba(123, 106, 220, 0.5) !important;
      }
      &-exclusive-active {
        background: linear-gradient(
          180deg,
          rgba(187, 160, 255, 0.17) 0%,
          rgba(30, 35, 121, 0.3) 99%
        );
      }
      .cutdown {
        position: absolute;
        box-sizing: border-box;
        padding: 3px 7px 3px 3px;
        border-radius: 8px;
        background: linear-gradient(
            91deg,
            #4fdeff -40%,
            #d9f8ff 52%,
            #e675ff 132%
          ),
          #fff200;
        .duration {
          padding: 11px 8px 11px 11px;
          // width: 64px;
          height: 28px;
          border-radius: 6px;
          background: #000000;
          img {
            width: 12px;
            height: 12px;
          }
          .ctime {
            font-size: 12px;
            font-weight: normal;
            line-height: 15px;
            color: #fff200;
            margin-left: 4px;
          }
        }
        .extra-credit {
          font-size: 10px;
          font-weight: 500;
          line-height: 11px;
          color: #000;
          margin-left: 9px;
        }
      }
      .title {
        img {
          width: 20px;
          height: 20px;
          margin-right: 4px;
        }
      }
      .cn-title {
        height: 22px;
        margin-bottom: 20px;
        font-size: 20px;
        font-weight: bold;
        line-height: 20px;
        &-exclusive {
          .short-year {
            background: linear-gradient(
              104deg,
              #f6b1ff 0%,
              #ecd3ff 53%,
              #ea8cff 100%
            );
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            text-fill-color: transparent;
          }
          .short-month {
            background: linear-gradient(
              104deg,
              #a6effd 0%,
              #c9f8fd 50%,
              #adffff 100%
            );
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            text-fill-color: transparent;
          }
          .period-year {
            background: linear-gradient(
              104deg,
              #f6b1ff 0%,
              #ecd3ff 53%,
              #ea8cff 100%
            );
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            text-fill-color: transparent;
            &::before {
              content: "";
              width: 13px;
              height: 22px;
              background: url("@/assets/img/credit/period-year.png");
              background-size: 100% 100%;
              margin-left: 6px;
              margin-right: 2px;
            }
            &::after {
              content: "";
              width: 13px;
              height: 22px;
              background: url("@/assets/img/credit/period-year.png");
              background-size: 100% 100%;
              margin-left: 4px;
              transform: scaleX(-1);
            }
          }
          .period-month {
            background: linear-gradient(
              104deg,
              #a6effd 0%,
              #c9f8fd 50%,
              #adffff 100%
            );
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            text-fill-color: transparent;
            &::before {
              content: "";
              width: 13px;
              height: 22px;
              background: url("@/assets/img/credit/period-month.png");
              background-size: 100% 100%;
              margin-left: 6px;
              margin-right: 2px;
            }
            &::after {
              content: "";
              width: 13px;
              height: 22px;
              background: url("@/assets/img/credit/period-month.png");
              background-size: 100% 100%;
              margin-left: 4px;
              transform: scaleX(-1);
            }
          }
        }
        &-normal {
          color: #fff;
          .short  {
            margin-right: 6px;
          }
        }
      }
      .pre-price {
        margin-bottom: 6px;
        font-size: 20px;
        color: rgba(255, 255, 255, 0.5);
        text-decoration: line-through;
      }
      .show-total-price {
        font-size: 20px;
        font-weight: 500;
        line-height: 24px;
        margin-bottom: 12px;
        color: #94adff;
      }
      .price {
        .flag {
          font-weight: bold;
          background: linear-gradient(132deg, #4fdeff 0%, #e675ff 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          text-fill-color: transparent;
        }
        .num {
          font-weight: bold;
          color: #fff;
          background: linear-gradient(132deg, #4fdeff 0%, #e675ff 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          text-fill-color: transparent;
        }
        .month {
          color: rgba(255, 255, 255, 0.5);
        }
      }
      .total {
        font-size: 12px;
        line-height: 20px;
        color: #94adff;
        border-bottom: 1px solid transparent;
        &-active {
          font-weight: 400;
          font-size: 16px;
          border-bottom: none;
        }
      }
      .btn {
        flex-shrink: 0;
        background: linear-gradient(100deg, #4fdeff 0%, #e675ff 100%);
        text-align: center;
        font-weight: bold;
        color: #000;
        display: flex;
        align-items: center;
        justify-content: center;
        &-disabled {
          background: linear-gradient(
              0deg,
              rgba(255, 255, 255, 0.6),
              rgba(255, 255, 255, 0.6)
            ),
            linear-gradient(100deg, #4fdeff 0%, #e675ff 100%);
        }
        &.is-loading {
          .loading {
            display: block;
          }
          .common {
            display: none;
          }
        }
        .loading {
          display: none;
          height: 20px;
          width: 20px;
          min-width: 20px;
          min-height: 20px;
          background: transparent;
          background-image: url(@/assets/img/loading-mini-white-3x.png) !important;
          background-size: 100% 100% !important;
          animation: animation-rotate-infinite 0.75s infinite normal linear;
          opacity: 1;
          visibility: visible;
          z-index: 1;
          svg {
            display: none;
          }
        }
      }
      .explain {
        div {
          &::before {
            content: "";
            background: url(@/assets/img/credit/check.png);
            background-size: 100% 100%;
          }
        }
        .active {
          color: #ffe95e;
          &::before {
            content: "";
            background: url(@/assets/img/credit/check-active.png);
            background-size: 100% 100%;
          }
        }
        .gary {
          color: rgba(255, 255, 255, 0.3);
          &::before {
            content: "";
            background: url(@/assets/img/credit/gary.png);
            background-size: 100% 100%;
          }
        }
      }
    }
  }
}

.pc-sub-plan {
  .tab {
    background: rgba(255, 255, 255, 0.1);
    .tab-item {
      padding: 6px 20px;
      font-size: 14px;
      line-height: 24px;
      margin-right: 4px;
    }
    .tab-item-active {
      border-radius: 42px;
    }
  }
  .list {
    padding-top: 24px;
    .item-pre-price {
      height: 649px;
    }
    .item {
      margin-right: 20px;
      padding: 28px 24px 10px;
      width: 420px;
      // height: 618px;
      border: 2px solid transparent;
      border-radius: 16px;
      background-clip: padding-box; /* 阻止背景延伸到边框区域 */
      &:last-child {
        margin-right: 0;
      }
      &:hover {
        background: url("@/assets/img/credit/item-active.png");
        background-clip: padding-box;
        background-size: 100% 100%;
        border: 2px solid #94adff;
      }
      .cutdown {
        top: 8px;
        right: 8px;
        width: max-content;
        box-sizing: border-box;
        padding: 3px 7px 3px 3px;
        border-radius: 8px;
        background: linear-gradient(
            91deg,
            #4fdeff -40%,
            #d9f8ff 52%,
            #e675ff 132%
          ),
          #fff200;
        .duration {
          padding: 11px 8px 11px 11px;
          // width: 64px;
          height: 28px;
          border-radius: 6px;
          background: #000000;
          img {
            width: 12px;
            height: 12px;
          }
          .ctime {
            font-size: 12px;
            font-weight: normal;
            line-height: 15px;
            color: #fff200;
            margin-left: 4px;
          }
        }
        .extra-credit {
          width: 93px;
          font-size: 10px;
          font-weight: 500;
          line-height: 11px;
          color: #000;
          margin-left: 9px;
          &.exclusive{
            width: 150px;
          }
        }
      }
      .title {
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 24px;
      }
      .price {
        .flag {
          font-weight: bold;
          font-size: 40px;
          line-height: 40px;
        }
        .num {
          // margin-left: 8px;
          font-size: 48px;
          font-weight: bold;
          line-height: 40px;
          &-active {
            font-size: 42px;
            line-height: 48px;
            font-weight: bold;
            background: linear-gradient(105deg, #4fdeff 0%, #e675ff 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            text-fill-color: transparent;
            z-index: 3;
            margin-bottom: 16px;
          }
        }
        .month {
          font-size: 20px;
          line-height: 58px;
          margin-left: 6px;
          &-active {
            font-size: 42px;
            line-height: 48px;
            font-weight: bold;
            background: linear-gradient(105deg, #4fdeff 0%, #e675ff 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            text-fill-color: transparent;
            z-index: 3;
            margin-bottom: 16px;
          }
        }
      }
      .total {
        margin-top: 0px;
      }
      .under-line {
        width: max-content;
        border-bottom: 1px solid #94adff;
      }
      .btn {
        margin: 24px 0;
        height: 56px;
        border-radius: 56px;
        font-size: 16px;
        line-height: 56px;
      }
      .explain {
        div {
          &::before {
            content: "";
            width: 20px;
            height: 20px;
            margin-right: 4px;
          }
          font-size: 12px;
          line-height: 20px;
          margin-bottom: 15px;
        }
        .active {
          &::before {
            content: "";
            width: 20px;
            height: 20px;
          }
        }
      }
    }
  }
}

.mobile-sub-plan {
  .tab {
    background: rgba(255, 255, 255, 0.1);
    .tab-item {
      padding: 2px 16px;
      font-size: 12px;
      line-height: 24px;
      margin-right: 4px;
    }
    .tab-item-active {
      border-radius: 52px;
    }
  }
  .list {
    width: 100%;
    padding: 20px 24px 0;
    flex-direction: column;
    .item {
      height: max-content;
      margin-bottom: 12px;
      border-radius: 13px;
      padding: 20px 20px 6px;
      .cutdown {
        align-items: flex-start;
        top: 6px;
        right: 6px;
        width: max-content;
        box-sizing: border-box;
        padding: 3px 7px 3px 3px;
        border-radius: 8px;
        background: linear-gradient(
            91deg,
            #4fdeff -40%,
            #d9f8ff 52%,
            #e675ff 132%
          ),
          #fff200;
        .duration {
          padding: 11px 8px 11px 8px;
          // width: 64px;
          height: 28px;
          border-radius: 6px;
          background: #000000;
          img {
            width: 12px;
            height: 12px;
          }
          .ctime {
            font-size: 12px;
            font-weight: normal;
            line-height: 15px;
            color: #fff200;
            margin-left: 4px;
          }
        }
        .extra-credit {
          margin-top: 2px;
          width: 68px;
          font-size: 9px;
          font-weight: 500;
          line-height: 12px;
          color: #000;
          margin-left: 4px;
          &.exclusive{
            width: 100px;
          }
        }
      }
      .title {
        font-size: 16px;
        line-height: 16px;
        margin-bottom: 20px;
      }
      .price {
        .flag {
          font-weight: bold;
          font-size: 32px;
          line-height: 36px;
        }
        .num {
          margin-left: 4px;
          font-size: 40px;
          line-height: 40px;
        }
        .month {
          font-size: 16px;
          line-height: 56px;
          margin-left: 6px;
          &-active {
            font-size: 40px;
            line-height: 40px;
            font-weight: bold;
            background: linear-gradient(105deg, #4fdeff 0%, #e675ff 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            text-fill-color: transparent;
            z-index: 3;
            margin-bottom: 10px;
          }
        }
      }
      .btn {
        margin: 16px 0;
        height: 46px;
        border-radius: 56px;
        font-size: 14px;
        line-height: 46px;
        color: #000;
        &-disabled {
          background: linear-gradient(
              0deg,
              rgba(255, 255, 255, 0.6),
              rgba(255, 255, 255, 0.6)
            ),
            linear-gradient(100deg, #4fdeff 0%, #e675ff 100%);
        }
      }
      .explain {
        div {
          &::before {
            content: "";
            width: 16px;
            height: 16px;
            margin-right: 6px;
            opacity: 1;
          }
          font-size: 12px;
          line-height: 16px;
          margin-bottom: 14px;
          opacity: 0.8;
        }
        .active {
          &::before {
            content: "";
            width: 16px;
            height: 16px;
          }
        }
      }
    }
  }
}
</style>
